import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const ItemMenu = ({ path, children, route, history }) => {
  let activeClass = route.match(path) ? 'active' : '';

  return (
    <a className={`mdl-navigation__link ${activeClass}`} onClick={ () => history.push(path) }>
      { children }
    </a>
  );
};

const mapStateToProps = (state) => ({ route: state.route });
export default withRouter(connect(mapStateToProps)(ItemMenu));



// WEBPACK FOOTER //
// ./src/components/ItemMenu.js